<template>
  <div>
    <div class="fw">
      <div class="header-title">平台服务</div>
      <h1 class="scroll-border-dom">{{$t('aboutus.title')}}</h1>
      <section>
        <p style="margin-bottom: 12px;">“O-TECH”系统是由上海科橘信息科技有限公司自主研发的、拥有独立知识产权的自由贸易协定优惠关税应用系统。</p>
        <p>“O-TECH”系统旨在为企业尤其是中小企业解决FTA优惠关税的信息查询及应用问题。通过该系统，企业可以简易快捷地了解到哪些进出口商品可以享受零关税，以及如何享受零关税，提高企业在FTA优惠关税方面的利用能力。</p>
      </section>
      <h1 style="margin-top: 35px;">{{$t('aboutus.title2')}}</h1>
      <section style="margin-bottom:15px">
        <p>同时，“O-TECH”还提供完备的线下服务，与线上服务共同塑造全方位的一站式体验，以协助企业以最优方式运用FTA优惠关税系统。“O-TECH”线下服务包括：</p>
      </section>
      <ul class="ofl">
        <li>
          <div class="sn">1</div>
          <div class="title">合规管理</div>
          <div class="desc">为企业提供综合的贸易合规管理解决方案；</div>
        </li>
        <li>
          <div class="sn">2</div>
          <div class="title">业务咨询</div>
          <div class="desc">为企业提供一对一咨询，根据企业自身需求特点，提供量身定制的贸易咨询服务，包括关税筹划、预裁定申请、流程梳理、政策解读等；</div>
        </li>
        <li>
          <div class="sn">3</div>
          <div class="title">专业培训</div>
          <div class="desc">为企业和相关从业人员提供FTA相关专业培训；</div>
        </li>
        <li>
          <div class="sn">4</div>
          <div class="title">磋商协助</div>
          <div class="desc">如果企业在申请FTA优惠待遇时发生困难，可以协助企业与监管部门进行磋商和沟通，以便企业享受优惠待遇；帮助企业在海关稽查和缉私过程中处理相关问题。</div>
        </li>
      </ul>
    </div>

    <div class="zj" style="margin-top: 50px">
      <div class="header-title">咨询专家</div>
      <h1 class="scroll-border-dom">合规咨询类</h1>
      <ul>
        <li>
          <div class="title">预裁定</div>
          <div class="desc">提供预裁定咨询服务并协助企业向海关递交申请与获得裁定。预归类、预审价、原产地预确定</div>
        </li>
        <li>
          <div class="title">贸易合规</div>
          <div class="desc">为企业在特定国家或地区的进出口活动提供法律法规咨询。AEO咨询、FTA咨询、贸易管制咨询、知识产权边境保护</div>
        </li>
        <li>
          <div class="title">海关稽查</div>
          <div class="desc">协助应对海关稽查，准备说明资料，最小化稽查风险。原产地稽查、归类稽查、价格稽查、加工贸易稽查</div>
        </li>
      </ul>
      <h1 class="scroll-border-dom icon2">系统实施类</h1>
      <ul>
        <li>
          <div class="title">关税筹划</div>
          <div class="desc">根据企业的贸易现状与需求进行全面的国际业务梳理与战略筹划。确定实施关税筹划后可产生的节税效益与可行性</div>
        </li>
        <li>
          <div class="title">选择系统</div>
          <div class="desc">根据企业的不同需求来协助企业选择适合的贸易合规管理系统帮助企业了解国际上不同的管理系统的特点与功能，根据企业的性质、所属产业类型、<p style="margin-top: 5px;">贸易方式、经营规模等情况作出最佳选择</p></div>
        </li>
        <li>
          <div class="title">模块设计</div>
          <div class="desc">协助企业确定系统的基本功能模块，如商品进出口信息管理、报关单证管理、加工贸易管理、供应商管理等，帮助企业实现信息化集成管理功能</div>
        </li>
        <li>
          <div class="title">系统维护</div>
          <div class="desc">为企业提供系统运行及数据信息的维护更新服务，为企业的从业人员提供更多的专业化培训，以保障系统的正常管理与运行</div>
        </li>
      </ul>
    </div>
    <div class="hp" style="margin-top: 50px">
      <div class="header-title">使用帮助</div>
      <h1 class="scroll-border-dom">产品使用手册</h1>
      <ul>
        <li>
          <div class="title">税率查询</div>
          <div class="desc">RCEP协定的大多数成员与中国有多套同时实施的FTA（如韩国、新加坡、柬埔寨和中国有3套同时适用的FTA），每套FTA在当年的降税幅度不同，企业需要查询到所有可适用的协定税率，并比较特定税号的商品在不同FTA中的优惠税率，才能选出最优关税。本系统可以根据商品税号一键查询所有可适用的FTA优惠关税信息，以最新2022年税则为依据为企业推荐最低税率。</div>
        </li>
        <li>
          <div class="title">税则查询</div>
          <div class="desc">企业只需要输入商品所应对的税号，便可以一键查询到所有影响进出口的监管政策，包括许可证件、出口税费、中美加征、反倾销反补贴、增值税、消费税等一揽子贸易政策信息。</div>
        </li>
        <li>
          <div class="title">原产地规则</div>
          <div class="desc">本系统的原产地规则查询和判定功能，可支撑企业申请”经核准出口商资质”，并在RCEP各成员国互认，企业可自主签发原产地声明并在各成员国享受优惠关税。</div>
        </li>
      </ul>
      <h1 class="scroll-border-dom icon2">产品操作视频</h1>
      <Row :gutter="20" class="videos">
        <Col span="6">
          <a class="item" target="_blank" href="https://v.youku.com/v_show/id_XNTE2NzA5MzM0MA==.html?spm=a2h0c.8166622.PhoneSokuUgc_7.dtitle">
            <div class="thumb">
              <img src="http://vthumb.ykimg.com/0541060160C098E10000017364054EF6?x-oss-process=image/resize,w_1895/format,webp/interlace,1">
              <div class="play-btn"><svg-icon icon-class="play2" class-name="fa-play"></svg-icon></div>
            </div>
            <span>海关程序与贸易便利化解析</span>
          </a>
        </Col>
        <Col span="6">
          <a class="item" target="_blank" href="https://v.youku.com/v_show/id_XNTE2MTMwNDc3Mg==.html?spm=a2h0c.8166622.PhoneSokuUgc_8.dtitle">
            <div class="thumb">
              <img src="//vthumb.ykimg.com/0541060160AF451000000162D20EE62F?x-oss-process=image/resize,w_1895/format,webp/interlace,1">
              <div class="play-btn"><svg-icon icon-class="play2" class-name="fa-play"></svg-icon></div>
            </div>
            <span>RCEP服务贸易与投资解读</span>
          </a>
        </Col>
        <Col span="6">
          <a class="item" target="_blank" href="https://v.youku.com/v_show/id_XNTE4OTQ2ODY4MA==.html?spm=a2h0c.8166622.PhoneSokuUgc_12.dtitle">
            <div class="thumb">
              <img src="//vthumb.ykimg.com/05410601610A3CAE00000175FD0EAA6B?x-oss-process=image/resize,w_1895/format,webp/interlace,1">
              <div class="play-btn"><svg-icon icon-class="play2" class-name="fa-play"></svg-icon></div>
            </div>
            <span>RCEP下法律风险防范与应对</span>
          </a>
        </Col>
        <Col span="6">
          <a class="item" target="_blank" href="https://v.youku.com/v_show/id_XNTgzMDcwMDUzMg==.html?spm=a2h0c.8166622.PhoneSokuUgc_22.dtitle">
            <div class="thumb">
              <img src="//vthumb.ykimg.com/0541060161CD0AA7A818176D7D0470D6?x-oss-process=image/resize,w_1895/format,webp/interlace,1">
              <div class="play-btn"><svg-icon icon-class="play2" class-name="fa-play"></svg-icon></div>
            </div>
            <span>RCEP背景下中小企业开拓市场简单分析</span>
          </a>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewServiceContent',
  // watch: {
  //   $route(){
  //     if (this.$route.query.anchor) {
  //       let anchor = document.querySelector(`.${this.$route.query.anchor}`)
  //       if(anchor) this.$scrollTo(anchor)
  //     }
  //   }
  // },
  // mounted () {
  //   this.$nextTick(() => {
  //     if (this.$route.query.anchor) {
  //       let anchor = this.$el.querySelector(`.${this.$route.query.anchor}`)
  //       if(anchor) this.$scrollTo(anchor)
  //     }
  //   })
  // }
}
</script>
<style scoped>
  .header-title{
    font-size: 18px;
    color: #000;
    font-weight: bold;
  }
  .fw h1{
    font-size: 15px;
    color: #333;
    margin: 25px 0 15px;
  }
  .fw section{
    color: #333;
    font-size: 14px;
    margin-bottom: 25px;
  }
  .fw section p{
    margin-bottom: 2px;
    line-height: 22px;
  }
  .fw ul li{
    margin-bottom: 25px;
    background: url("~@/assets/images/icons/about/1.png") 0 2px no-repeat transparent;
    background-size: 20px auto;
    padding-left: 35px;
  }
  .fw ul li.i2{
    background-image: url("~@/assets/images/icons/about/2.png");
  }
  .fw ul li.i3{
    background-image: url("~@/assets/images/icons/about/3.png");
  }
  .fw ul.ofl li{
    background-image: none;
    position: relative;
  }
  .fw ul.ofl li .sn{
    background-color: #2681FF;
    width: 16px;
    height: 16px;
    border-radius: 100px;
    color: #fff;
    text-align: center;
    line-height: 16px;
    font-size: 11px;
    position: absolute;
    top: 3px;
    left: 0;
  }
  .fw ul li .title{
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 6px;
    color: #333;
  }
  .fw ul li .desc{
    color: #333;
    font-size: 14px;
    line-height: 22px;
  }
  .zj h1,
  .hp h1{
    font-size: 15px;
    color: #1F8AFD;
    margin: 25px 0 0;
    padding-bottom: 20px;
    font-weight: normal;
    background: url("~@/assets/images/icons/help/1.png") 0 4px no-repeat transparent;
    padding-left: 22px;
    background-size: 14px auto;
  }
  .zj h1.icon2,
  .hp h1.icon2{
    margin-top: 35px;
    background-image: url("~@/assets/images/icons/help/2.png");
  }
  .zj ul,
  .hp ul{
    margin-left: 8px;
  }
  .zj ul li,
  .hp ul li{
    margin-bottom: 25px;
    background: url("~@/assets/images/icons/help/arrow.png") 0 5px no-repeat transparent;
    background-size: 8px auto;
    padding-left: 15px;
  }
  .zj ul li .title,
  .hp ul li .title{
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 6px;
    color: #333;
  }
  .zj ul li .desc,
  .hp ul li .desc{
    color: #333;
    font-size: 14px;
    line-height: 22px;
  }
  .videos .item{
    max-width: 323px;
    text-align: center;
    display: block;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2);
  }
  .videos .item img{
    width: 100%;
    display: block;
  }
  .videos .item span{
    padding: 16px 12px;
    font-size: 14px;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #666;
  }
  .videos .thumb{
    position: relative;
  }
  .videos .thumb .play-btn{
    width: 32px;
    height: 32px;
    position: absolute;
    left: 12px;
    bottom: 12px;
    background-color: rgba(39, 131, 255, .8);
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .videos .thumb .fa-play{
    font-size: 22px;
    color: #fff;
    position: relative;
    left: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/exportnew/Content.vue